import { createSelector } from 'reselect'

export const selectNodeEnv = () => process.env.NODE_ENV

export const selectIsProductionNodeEnv = createSelector(
  selectNodeEnv,
  env => env.toLowerCase().startsWith('p')
)

const ylopoHack = process.env.REACT_APP_DISABLE_YLOPO_HACK
export const selectDisableYlopoHack = () =>
  ylopoHack && ylopoHack.toLowerCase().startsWith('t')
